import React from "react";
import STAR_HALF from "../assets/star-half.png";
import STAR_FULL from "../assets/star-full.png";
import STAR_EMPTY from "../assets/star-empty.png";

const Stars = ({ averageRating }) => {
  const fullStars = Math.floor(averageRating);
  const hasHalfStar = averageRating % 1 !== 0;

  const renderStars = () => {
    const stars = [];

    for (let i = 0; i < fullStars; i++) {
      stars.push(<img key={i} src={STAR_FULL} alt="Full Star"/>);
    }

    if (hasHalfStar) stars.push(<img key="half" src={STAR_HALF} alt="Half Star"/>)

    while (stars.length < 5) {
        stars.push(<img key={stars.length} src={STAR_EMPTY} alt="Empty Star"/>)
    }

    return stars;
  };

  return <div className="star-rating">{renderStars()}</div>;
};

export default Stars;
